class SizeDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleOpenButtonClick = this.handleOpenButtonClick.bind(this);
    this.handleKeyUp = (evt) => evt.code === 'Escape' && this.close();
    this.handleTableHover = this.handleTableHover.bind(this);
    this.handleTableLeave = this.handleTableLeave.bind(this);
    this.handleTableClick = this.handleTableClick.bind(this);
    this.initSelectedSize = this.initSelectedSize.bind(this);
  }

  connectedCallback() {
    // Listen for Escape key
    this.addEventListener('keyup', this.handleKeyUp);
    // Listen for overlay click
    this.querySelector('#SizeDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    // Listen for open button click
    this.openButtons = document.querySelectorAll('#open-size-drawer');
    this.actionButton = this.querySelector('.size-guide--actions > button');
    this.BISOpen = this.querySelector('.size-guide--actions > modal-opener[data-modal="#Drawer-BackInStock"]');

    if(this.BISOpen){
      this.BISOpen.addEventListener('click', this.close.bind(this));
    }
    if(this.actionButton){
      this.actionButton.addEventListener('click', async ()=>{
        const isAppUserAgent = navigator.userAgent.includes('source:stikky');
        const variantId = this.querySelector('td.selected button')? this.querySelector('td.selected button').getAttribute('variant'):
                          this.querySelector('td.selected').parentElement.querySelector('button').getAttribute('variant');
        console.log("DEBUG: variantId ", variantId);
        if(isAppUserAgent && variantId){
          const addToCartResult = await StikkySDK.actions.addToCart({
            variantId: variantId,
            quantity: 1,
          });
          addToCartResult.fold(
            error => console.error(`addToCart Failed: ${error.message} (Type: ${error.type}, Name: ${error.name})`),
            cart => console.log("addToCart Success! Updated cart:", cart) // cart can be undefined if no data returned
          );
        }
        else{
          this.close();
          document.querySelector('.product-form__submit')?.click();
        }
      } );
    }
    if (this.openButtons.length > 0) {
      this.openButtons.forEach(button => button.addEventListener('click', this.handleOpenButtonClick));
    }
    // Table hover logic
    this.initTableHover();
    // Table click logic
    this.initTableClick();
    // Listen for size-tabs radio change
    this.initSizeTabs();

  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this.handleKeyUp);
    this.querySelector('#SizeDrawer-Overlay')?.removeEventListener('click', this.close.bind(this));
    if(this.BISOpen){
      this.BISOpen.removeEventListener('click', this.close.bind(this));
    }
    if (this.openButtons.length > 0) {
      this.openButtons.forEach(button => button.removeEventListener('click', this.handleOpenButtonClick));
    }
    // Remove table hover listeners
    this.cleanupTableHover();
    // Remove table click listeners
    this.cleanupTableClick();
  }

  handleOpenButtonClick(event) {
    const isAppUserAgent = navigator.userAgent.includes('source:stikky');
    if(!isAppUserAgent){
      event.preventDefault();
      this.open();
    }
  }

  open() {
    setTimeout(() => {
      this.classList.add('animate', 'active');
      // // Reset action button to disabled on open
      // const actionButton = this.querySelector('.size-guide--actions button');
      // if (actionButton) {
      //   actionButton.disabled = true;
      // }
      // Reset table units to cm on open
      this.updateTableUnits('cm');
      // Set the cm radio as checked
      const cmRadio = this.querySelector('input[name="size-tabs"][value="cm"]');
      if (cmRadio) cmRadio.checked = true;

      // Check and add size guide property input if needed, set name for open state
      this.ensureSizeGuideInput();
      this.setSizeGuideInputName('properties[_sizeguide]');

      this.initSelectedSize();

    });
    document.body.classList.add('overflow-hidden');
  }

    close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    // Change size guide input name after 0.5 second delay
    setTimeout(() => {
      this.setSizeGuideInputName('properties[_sizeguide_PDP]');
    }, 500);
  }

    ensureSizeGuideInput() {
    // Find the product form
    const cartForm = document.querySelector('form.product-form__form');
    if (!cartForm) return;

    // Check if input with either name already exists
    const existingInput = cartForm.querySelector('input[name="properties[_sizeguide]"], input[name="properties[_sizeguide_PDP]"]');
    if (existingInput) return;

    // Create and add the input if it doesn't exist (default to PDP name)
    const sizeGuideInput = document.createElement('input');
    sizeGuideInput.type = 'hidden';
    sizeGuideInput.name = 'properties[_sizeguide_PDP]';
    sizeGuideInput.value = 'true';

    cartForm.appendChild(sizeGuideInput);
  }

  setSizeGuideInputName(newName) {
    // Find the product form
    const cartForm = document.querySelector('form.product-form__form');
    if (!cartForm) return;

    // Find the size guide input with either possible name
    const sizeGuideInput = cartForm.querySelector('input[name="properties[_sizeguide]"], input[name="properties[_sizeguide_PDP]"]');
    if (sizeGuideInput) {
      sizeGuideInput.name = newName;
    }
  }

  initSelectedSize() {
    const selectedSize = document.querySelector('variant-selects input[name="Größe"]:checked');
    if(selectedSize){
      console.log("DEBUG: clcked btn ", this.querySelector(`td[data-size="${selectedSize.value}"] + td`));
      this.querySelector(`td[data-size="${selectedSize.value}"] + td`).dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  // --- Table hover logic ---
  initTableHover() {
    this.sizeGuideTable = this.querySelector('.size-guide--table table');
    if (!this.sizeGuideTable) return;
    this.tableCells = this.sizeGuideTable.querySelectorAll('th, td');
    this.tableCells.forEach(cell => {
      cell.addEventListener('mouseenter', this.handleTableHover);
      cell.addEventListener('mouseleave', this.handleTableLeave);
    });
  }

  cleanupTableHover() {
    if (!this.tableCells) return;
    this.tableCells.forEach(cell => {
      cell.removeEventListener('mouseenter', this.handleTableHover);
      cell.removeEventListener('mouseleave', this.handleTableLeave);
    });
  }

  handleTableHover(e) {
    const cell = e.currentTarget;
    const table = this.sizeGuideTable;
    if (!table) return;
    // Find cell index and row
    const row = cell.parentElement;
    const rowIndex = Array.from(row.parentElement.children).indexOf(row);
    const cellIndex = Array.from(cell.parentElement.children).indexOf(cell);
    // Highlight all cells in the same row
    if(cell.tagName !== 'TH'){
      Array.from(row.children).forEach(c => c.classList.add('highlight'));
    }
    // Highlight all cells in the same column
    if(!cell.getAttribute('data-size')){
      Array.from(table.rows).forEach(r => {
        if (r.children[cellIndex]) {
          r.children[cellIndex].classList.add('highlight');
        }
      });
    }
  }

  handleTableLeave(e) {
    // Remove all highlights
    if (!this.sizeGuideTable) return;
    this.sizeGuideTable.querySelectorAll('.highlight').forEach(cell => cell.classList.remove('highlight'));
  }

  // --- Table click logic ---
  initTableClick() {
    if (!this.sizeGuideTable) return;
    this.tableTds = this.sizeGuideTable.querySelectorAll('td');
    this.tableTds.forEach(td => {
      td.addEventListener('click', this.handleTableClick);
    });
  }

  cleanupTableClick() {
    if (!this.tableTds) return;
    this.tableTds.forEach(td => {
      td.removeEventListener('click', this.handleTableClick);
    });
  }

  handleTableClick(e) {
    // Remove 'selected' from all tds
    this.tableTds.forEach(td => td.classList.remove('selected'));
    // Add 'selected' to clicked td
    e.currentTarget.classList.add('selected');
    // Enable/disable the action button
    this.toggleActionButton();
    // Select the corresponding variant radio input
    this.selectVariantInputForSelectedRow(e.currentTarget);
  }

  selectVariantInputForSelectedRow(selectedTd) {
    // Find the row (tr) of the selected td
    const row = selectedTd.closest('tr');
    if (!row) return;
    // Get the first td's text (size label)
    const sizeLabel = row.querySelector('td')?.textContent?.trim();
    if (!sizeLabel) return;
    // Find the input in variant-selects with name 'Größe' and value == sizeLabel
    // (case-insensitive match for robustness)
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    const sizeInput = variantSelects.querySelector("input[name='Größe'][value='" + CSS.escape(sizeLabel) + "']");
    console.log("DEBUG: sizeInput ", sizeInput, sizeInput.dataset.disabled);

    if (sizeInput  ) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      if(this.actionButton && this.actionButton.classList.contains('hidden')){
        this.actionButton.classList.remove('hidden');
      }
      if(this.BISOpen && !this.BISOpen.classList.contains('hidden')){
        this.BISOpen.classList.add('hidden');
      }
    }
    if (sizeInput && sizeInput.dataset.disabled){
      if(this.actionButton && !this.actionButton.classList.contains('hidden')){
        this.actionButton.classList.add('hidden');
      }
      if(this.BISOpen && this.BISOpen.classList.contains('hidden')){
        this.BISOpen.classList.remove('hidden');
      }
    }
  }

  toggleActionButton() {
    const hasSelected = Array.from(this.tableTds).some(td => td.classList.contains('selected'));
    if (this.actionButton) {
      this.actionButton.disabled = !hasSelected;
    }
  }

  initSizeTabs() {
    this.sizeTabInputs = this.querySelectorAll('input[name="size-tabs"]');
    this.sizeTabInputs.forEach(input => {
      input.addEventListener('change', this.handleSizeTabChange.bind(this));
    });
    // Set initial values to cm
    this.updateTableUnits('cm');
  }

  handleSizeTabChange(e) {
    const unit = e.target.value;
    this.updateTableUnits(unit);
  }

  updateTableUnits(unit) {
    // Find all td > button with data-cm
    const buttons = this.querySelectorAll('.size-guide--table td > button[data-cm]');
    buttons.forEach(btn => {
      const cmValue = btn.getAttribute('data-cm');
      if (!cmValue) return;
      if (unit === 'cm') {
        btn.textContent = cmValue;
      } else if (unit === 'in') {
        // Convert to inches (1 cm = 0.393701 in), round to 2 decimals
        const num = parseFloat(cmValue);
        if (!isNaN(num)) {
          btn.textContent = (num * 0.3937007874).toFixed(1);
        } else {
          btn.textContent = cmValue;
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('size-drawer', SizeDrawer);
});
